<script>
import { getLocalPathWithQuery } from './util'

export let data

$: formpath = getLocalPathWithQuery('/form', {frm: data.formid})

</script>

<div>
<dl>
  <dt>PID</dt> <dd>{data.subject}</dd>
  <dt>Namespace</dt> <dd>{data.namespacename}</dd>

  <dt>Field</dt>
   <dd>{data.alias ? `${data.alias} (${data.fieldname})` : data.fieldname}</dd>
  <dt>Site code</dt> <dd>{data.sitecode || ''}</dd>

  <dt>Form</dt> <dd><a href={formpath}>{data.shortformname}</a></dd>
  <dt>Internal IDs (form, field)</dt> <dd>{data.formid}, {data.formfieldid}</dd>

  <dt>Repeat instance</dt> <dd>{data.repeatinstance || ''}</dd>
  <dt>Event name</dt> <dd>{data.eventname || ''}</dd>

  <dt>External source</dt> <dd>{data.externalname}</dd>
  <dt>Source type</dt> <dd>{data.sourcetype}</dd>

  <dt>K-value</dt> <dd>{data.kstr || ''}</dd>
  <dt>K-status</dt> <dd>{data.kstatus}</dd>

  <dt>F-value</dt> <dd>{data.fstr || ''}</dd>
  <dt>F-status</dt> <dd>{data.fstatus}</dd>

  <dt>Custom validation logic</dt>
   <dd class=fldcheckexec><pre>{data.checkexec || ''}</pre></dd>

  <dt>Error type</dt> <dd>{data.errortype || ''}</dd>
  <dt>Error text</dt> <dd>{data.errortext || ''}</dd>

  <dt>Error status</dt> <dd>{data.errorstatus || ''}</dd>
  <dt>Has custom text</dt> <dd>{data.hascustomtext ? 'yes' : 'no'}</dd>

  <dt>Query control</dt> <dd>{data.querycontrol || ''}</dd>
  <dt>Error record created</dt> <dd>{data.fecreateddt}</dd>

</dl>
</div>

<style>
  dl {
    display: grid;
    grid-template-columns: fit-content(50%) fit-content(50%) fit-content(50%)  auto;
    column-gap: .5rem;
    font-size: 0;  /* Hack to remove extra space above grid */
  }
  dt, dd {
    font-size: .8rem;
    line-height: 1.5em;
  }
  dt {
    margin: 0 0 0 2em;
    text-align: right;
    font-weight: bold;
  }
  dd {
    margin: 0; 
  }
  dd pre {
    margin: 0;
    font-size: .6rem;
    line-height: 1.5em;
    white-space: pre-wrap;
  }
  dd.fldcheckexec {
    grid-column: 2 / span 3
  }
</style>
